import { render } from "./AlertManuale.vue?vue&type=template&id=12474980&ts=true"
import script from "./AlertManuale.vue?vue&type=script&lang=ts"
export * from "./AlertManuale.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__